module.exports = __webpack_public_path__ + "img/blank-image.0c9e459c.svg";